import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

/**
 * Reusable Pricing Card Component
 * @param {string} name - Plan name
 * @param {string} subtitle - Plan subtitle
 * @param {string[]} features - Array of feature strings
 * @param {string} link - Link to plan page
 */
const PricingCard = ({ name, subtitle, features, link }) => (
  <Card className="h-100 shadow-sm pricing-card d-flex">
    <div className="pricing-header bg-teal text-white p-4">
      <h5 className="fw-bold mb-1">{name}</h5>
      <p className="mb-0 small">{subtitle}</p>
    </div>

    <Card.Body className="d-flex flex-column">
      <ul className="text-start flex-grow-1">
        {features.map((feature, idx) => (
          <li key={idx}>{feature}</li>
        ))}
      </ul>

      <Button
        size="md"
        className="px-4 py-2 landing-primary-class align-self-center rounded-5"
        as={Link}
        to={link}
      >
        Choose Plan
      </Button>
    </Card.Body>
  </Card>
);

export default PricingCard;
